import axiosInstance from "../Config/axiosConfig";

const getHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  const storedDeviceId = localStorage.getItem("deviceId");
  const storedUserIp = localStorage.getItem("userIp");

  return {
    Authorization: `Bearer ${accessToken}`,
    ...(storedDeviceId && { UserDevice: storedDeviceId }),
    ...(storedUserIp && { UserIPAddress: storedUserIp }),
    "Content-Type": "application/json",
  };
};

export const fetchStudents = async () => {
  try {
    const response = await axiosInstance.get("/Admin/get-students", {
      headers: getHeaders(),
    });

    console.log("Fetch students response:", response.data);

    // Handle different response formats
    let studentsData = [];
    if (Array.isArray(response.data)) {
      studentsData = response.data;
    } else if (response.data && Array.isArray(response.data.students)) {
      studentsData = response.data.students;
    } else if (response.data && response.data.data) {
      studentsData = Array.isArray(response.data.data) ? response.data.data : [response.data.data];
    } else {
      studentsData = [response.data]; // Wrap single object in array
    }

    return studentsData;
  } catch (error) {
    console.error("Error fetching students:", error);
    throw error;
  }
};

export const setDefaultPassword = async (userId) => {
  try {
    const response = await axiosInstance.get(
      `https://beyondschools.co.tz:8443/api/Admin/set-default-password/${userId}`,
      {
        headers: getHeaders(),
      }
    );
    console.log("check reset password",response.data)
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to set default password');
    }
  } catch (error) {
    console.error('Error setting default password:', error);
    throw error;
  }
};

// ApiServices/getStudentDetailsService.js
export const fetchStudentDetails = async (userId) => {
  try {
    const userTimeZone = "Africa/Nairobi";

    const response = await axiosInstance.post(
      'https://beyondschools.co.tz:8443/api/Admin/get-student-details',
      {
        user_id: userId,
        time_zone: userTimeZone
      },
      {
      headers: getHeaders(),
      }
    );
    console.log("Student details response:", response.data);
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to fetch student details');
    }
  } catch (error) {
    console.error('Error fetching student details:', error);
    
    if (error.response?.status === 401) {
      localStorage.removeItem("accessToken");
      window.location.href = '/login';
    }
    
    throw error;
  }
};